'use client';

import { useTranslations } from 'next-intl';
import { Box, HStack, Text, useDisclosure, VStack } from '@chakra-ui/react';
import {
  DialogBackdrop,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogRoot,
} from '@/components/ui/dialog';
import OffHoursModal from './OffHoursModal';
import { Form } from './form';
import { IWorkHour } from '@/_types';
import Calendar from '@/_assets/icons/calendar.svg';
import Image from 'next/image';

interface IProps {
  scheduleData?: { working_hours: IWorkHour[] };
  formattedTime: string;
  interval: number;
  onConfirm: (time: string) => void;
  showTrigger?: boolean;
  open?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
}

export default function TimeDesktop({
  formattedTime,
  interval = 0,
  scheduleData,
  onConfirm,
  showTrigger = true,
  open: controlledOpen,
  onOpen: controlledOnOpen,
  onClose: controlledOnClose,
}: IProps) {
  const t = useTranslations();
  const disclosure = useDisclosure();
  const open = controlledOpen ?? disclosure.open;
  const onOpen = controlledOnOpen ?? disclosure.onOpen;
  const onClose = controlledOnClose ?? disclosure.onClose;

  return (
    <Box>
      {showTrigger && (
        <>
          <Text fontSize='xl' fontWeight={600} mb={4} lineHeight={1.2}>
            {t('order_for_a_specific_time')}
          </Text>
          <HStack
            onClick={onOpen}
            cursor={'pointer'}
            bg={'background'}
            px={4}
            py={3}
            rounded={16}
            height={'56px'}
          >
            <HStack gap={2} flex={1} h={6}>
              <VStack align='flex-start' justify='center' gap={0}>
                <Text fontSize={'xs'} color={'gray.600'}>
                  {t('select_date_time')}
                </Text>
                <Text
                  fontWeight='500'
                  color={formattedTime ? 'inherit' : 'gray.600'}
                  lineHeight={1}
                >
                  {formattedTime}
                </Text>
              </VStack>
            </HStack>
            <Image src={Calendar} alt='Calendar' width={20} height={20} />
          </HStack>
          <OffHoursModal onPreorder={onOpen} />
        </>
      )}

      <DialogRoot
        open={open}
        onOpenChange={onClose}
        scrollBehavior='inside'
        id='time-select'
      >
        <DialogBackdrop />
        <DialogContent maxW='600px'>
          <DialogBody pt={6} px={2} pb={0}>
            <Form
              interval={interval}
              scheduleData={scheduleData}
              onConfirm={(val) => {
                onClose();
                onConfirm(val);
              }}
            />
          </DialogBody>
          <DialogCloseTrigger />
        </DialogContent>
      </DialogRoot>
    </Box>
  );
}
